;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:propstrata-app":true});}catch(e){}}();import { TOUR_OVERLAY_GROUPS } from "@/features/onboarding-tours/orchestrator/tour-overlay-groups";
import { tourStep } from "@/features/onboarding-tours/orchestrator/tour-step-builder";
import {
	TOUR_TARGETS,
	tourSelector,
} from "@/features/onboarding-tours/orchestrator/tour-target-ids";
import { defineTour } from "@/features/onboarding-tours/registry/define-tour";
import { TourCategory } from "@/features/onboarding-tours/types/tour-category";

const leaderboardConfigButtonTarget = tourSelector(
	TOUR_TARGETS.leaderboardConfigButton,
);
const leaderboardDisplayModeTarget = tourSelector(
	TOUR_TARGETS.leaderboardDisplayMode,
);
const leaderboardStaffTabsTarget = tourSelector(
	TOUR_TARGETS.leaderboardStaffTabs,
);
const leaderboardBucketSidebarTarget = tourSelector(
	TOUR_TARGETS.leaderboardBucketSidebar,
);
const leaderboardBucketEditorPaneTarget = tourSelector(
	TOUR_TARGETS.leaderboardBucketEditorPane,
);
const leaderboardSaveButtonTarget = tourSelector(
	TOUR_TARGETS.leaderboardSaveButton,
);

export const configureLeaderboardTour = defineTour({
	buildSteps: () => [
		tourStep({
			content:
				"Open configuration to customize scoring modes, metrics, weights, and display options.",
			data: {
				advanceOn: "target-click",
				watchTargetClick: {
					selector: leaderboardConfigButtonTarget,
					stepIndex: 1,
				},
			},
			placement: "bottom",
			spotlightPadding: 8,
			target: leaderboardConfigButtonTarget,
			title: "Configure the leaderboard",
		}),
		tourStep({
			content: "Switch between numerical scores and letter grades.",
			data: {
				overlayGroup: TOUR_OVERLAY_GROUPS.leaderboardConfig,
			},
			effect: "openLeaderboardConfig",
			placement: "bottom",
			scrollBefore: leaderboardDisplayModeTarget,
			target: leaderboardDisplayModeTarget,
			title: "Scores or grades",
			waitForTarget: true,
		}),
		tourStep({
			content: "Configure rankings separately for each staff type.",
			data: {
				overlayGroup: TOUR_OVERLAY_GROUPS.leaderboardConfig,
			},
			effect: "openLeaderboardConfig",
			placement: "bottom",
			scrollBefore: leaderboardStaffTabsTarget,
			spotlightPadding: 8,
			target: leaderboardStaffTabsTarget,
			title: "Staff groups",
			waitForTarget: true,
		}),
		tourStep({
			content:
				"Enable a data bucket with its switch, then select it to configure metrics.",
			data: {
				overlayGroup: TOUR_OVERLAY_GROUPS.leaderboardConfig,
			},
			effect: "openLeaderboardConfig",
			placement: "left",
			scrollBefore: leaderboardBucketSidebarTarget,
			spotlightPadding: 8,
			target: leaderboardBucketSidebarTarget,
			title: "Data buckets",
			waitForTarget: true,
		}),
		tourStep({
			content:
				"Add metrics and balance weights to total 100% in the editor panel.",
			data: {
				overlayGroup: TOUR_OVERLAY_GROUPS.leaderboardConfig,
			},
			effect: "openLeaderboardConfig",
			placement: "auto",
			scrollBefore: leaderboardBucketEditorPaneTarget,
			spotlightPadding: 12,
			target: leaderboardBucketEditorPaneTarget,
			title: "Metrics and weights",
			waitForTarget: true,
		}),
		tourStep({
			content:
				"Apply your configuration to update leaderboard rankings when you are ready.",
			data: {
				overlayGroup: TOUR_OVERLAY_GROUPS.leaderboardConfig,
			},
			effect: "openLeaderboardConfig",
			placement: "bottom",
			scrollBefore: leaderboardSaveButtonTarget,
			spotlightPadding: 8,
			target: leaderboardSaveButtonTarget,
			title: "Save changes",
			waitForTarget: true,
		}),
	],
	catalog: {},
	category: TourCategory.leaderboard,
	description:
		"Set scoring modes, metrics, weights, and grading for staff rankings.",
	eligibility: { requiresLeaderboardEdit: true },
	id: "configure-leaderboard",
	launch: {
		startRoute: ({ workspaceId }) => `/${workspaceId}/leaderboard`,
	},
	tags: ["leaderboard", "grading", "scores", "metrics", "configuration"],
	title: "Configure the leaderboard",
});
